import React, { useRef } from "react";


import Intro from "./components/Intro/Intro";
import ImageSplit from "./components/ImageSplit/ImageSplit";
import IntroDescriptionOne from "./components/IntroDescriptionOne/IntroDescriptionOne";
import IntroDescriptionTwo from "./components/IntroDescriptionTwo/IntroDescriptionTwo";

import { FaLink } from "react-icons/fa"

import './IntroPage.css'


const Dsgvo = function (props) {

    const descriptionRef = useRef();


    return (

        <React.Fragment>







            <div className="page-body page-body-first-element" >
                <div className="page-content">
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Vorwort</span></h2>
                            <p>
                                Bevor du unsere Dienste und Inhalte nutzt, bitten wir dich, diesen Disclaimer und unsere Datenschutzrichtlinien sorgfältig durchzulesen.
                                Hier erfährst du, wie unsere Website funktioniert, welche Informationen wir sammeln und wie wir diese verwenden, sowie die Bedingungen und Einschränkungen, die für die Nutzung unserer Website gelten.
                                Indem du unsere Website weiterhin nutzt, erklärst du dich mit diesen Bedingungen und Richtlinien einverstanden.
                                Solltest du Fragen oder Bedenken haben, zögere nicht, uns zu kontaktieren.
                            </p>
                        </div>
                    </div>
                    <br></br>
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Datenschutzerklärung - Grundlegendes</span></h2>
                            <p>
                                Diese Datenschutzerklärung soll die Nutzer dieser Website über die Art, den Umfang und
                                den Zweck der Erhebung und Verwendung personenbezogener Daten durch den
                                Websitebetreiber Combat Sports Lübeck e.V. informieren.

                            </p>
                            <p>
                                Der Websitebetreiber nimmt deinen Datenschutz sehr ernst und behandelt deine
                                personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Vorschriften. Da
                                durch neue Technologien und die ständige Weiterentwicklung dieser Webseite Änderungen
                                an dieser Datenschutzerklärung vorgenommen werden können, empfehlen wir Ihnen sich die
                                Datenschutzerklärung in regelmäßigen Abständen wieder durchzulesen.
                            </p>
                            <p>
                                Definitionen der verwendeten Begriffe (z.B. “personenbezogene Daten” oder “Verarbeitung”)
                                findest du in <a class="underline cs-text-link" href="https://beck-online.beck.de/?vpath=bibdata/komm/EhmannSelmayrKoDSGVO_1/EWG_DSGVO/cont/EhmannSelmayrKoDSGVO.EWG_DSGVO.a4.htm"><FaLink className="icon-link-text " />Art. 4 DSGVO</a>.
                            </p>
                        </div>
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Zugriffsdaten</span></h2>
                            <p>
                                Der Seitenprovider, erhebt (s. Art. 6 Abs. 1 lit. f. DSGVO) Daten über Zugriffe auf die Website und speichert
                                diese als „Server-Logfiles“ auf dem Server der Website ab. Folgende Daten werden so
                                protokolliert:
                            </p>
                            <ul>
                                <li>
                                    Besuchte Website
                                </li>
                                <li>
                                    Uhrzeit zum Zeitpunkt des Zugriffes
                                </li>
                                <li>
                                    Menge der gesendeten Daten in Byte
                                </li>
                                <li>
                                    Quelle/Verweis, von welchem du auf die Seite gelangtest
                                </li>
                                <li>
                                    Verwendeter Browser
                                </li>
                                <li>
                                    Verwendetes Betriebssystem
                                </li>
                                <li>
                                    Verwendete IP-Adresse
                                </li>
                            </ul>
                            <p>
                                Der Websitebetreiber nimmt den Datenschutz sehr ernst und behandelt deine
                                personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Vorschriften. Da
                                durch neue Technologien und die ständige Weiterentwicklung dieser Webseite Änderungen
                                an dieser Datenschutzerklärung vorgenommen werden können, empfehlen wir dir, die
                                Datenschutzerklärung in regelmäßigen Abständen wieder durchzulesen.
                            </p>
                            <p>
                                Die Server-Logfiles werden für maximal 7 Tage gespeichert und anschließend gelöscht. Die
                                Speicherung der Daten erfolgt aus Sicherheitsgründen, um z. B. Missbrauchsfälle aufklären
                                zu können. Müssen Daten aus Beweisgründen aufgehoben werden, sind sie solange von der
                                Löschung ausgenommen bis der Vorfall endgültig geklärt ist.
                            </p>
                        </div>

                        <div className="intro-content">
                            <h2 className="intro-name"><span>Umgang mit Kontaktdaten</span></h2>
                            <p>
                                Nimm mit uns als Websitebetreiber durch die angebotenen Kontaktmöglichkeiten
                                Verbindung auf, werden deine Angaben gespeichert, damit auf diese zur Bearbeitung und
                                Beantwortung deiner Anfrage zurückgegriffen werden kann. Ohne deine Einwilligung werden
                                diese Daten nicht an Dritte weitergegeben
                            </p>
                        </div>
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Cookies</span></h2>
                            <p>
                                Wir verzichten bewusst auf die Verwendung von Cookies jeglicher Art.
                                Das bedeutet, dass wir keinerlei persönliche Informationen oder Daten von dir sammeln, ohne deine ausdrückliche Zustimmung.
                                Deine Privatsphäre und Datensicherheit sind uns wichtig, und wir sind bestrebt, die Online-Erfahrung so transparent und datenschutzfreundlich wie möglich zu gestalten.
                            </p>
                        </div>
                    </div>
                </div>

            </div>








        </React.Fragment >
    )
}

export default Dsgvo